import { UPDATE_ESSENTIAL_SCORE } from '../action_types';

export default (essentialScore) => ({
  type: UPDATE_ESSENTIAL_SCORE,
  essentialScore,
});
